import * as types from "../types/userTypes";

const initialState = {
  users: [],
  stats: null,
  loading: false,
  error: null,
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_USERS_REQUEST:
    case types.FETCH_USER_STATS_REQUEST:
    case types.CREATE_USER_REQUEST:
    case types.UPDATE_USER_REQUEST:
    case types.DELETE_USER_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_USERS_SUCCESS:
      return { ...state, loading: false, users: action.payload };

    case types.FETCH_USER_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };

    case types.CREATE_USER_SUCCESS:
      return { ...state, loading: false, users: [...state.users, action.payload] };

    case types.UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: state.users.map((u) => (u._id === action.payload._id ? action.payload : u)),
      };

    case types.DELETE_USER_SUCCESS:
      return { ...state, loading: false, users: state.users.filter((u) => u._id !== action.payload) };

    case types.FETCH_USERS_FAILURE:
    case types.FETCH_USER_STATS_FAILURE:
    case types.CREATE_USER_FAILURE:
    case types.UPDATE_USER_FAILURE:
    case types.DELETE_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
